import angular from 'angular';
import moment from 'moment';

import templateUrl from './payroll-financials-dashboard.component.html';

export const PayrollFinancialsDashboardComponent = {
    controller: PayrollFinancialsDashboardController,
    controllerAs: "vm",
    bindings: {
        startDateStr: "@startDate",
        endDateStr: "@endDate"
    },
    templateUrl
};

function PayrollFinancialsDashboardController($q, $window, apexApiUrl, dashboardSummaryService,
    divisionService, payrollDashboardService, payrollFinancialsService, utilityService) {
    'ngInject';
    const vm = this;
    vm.$onInit = $onInit;
    vm.averageDashboardSummaries;
    vm.bottomDashboardSummaries;
    vm.bottomLimit = 15;
    vm.comparablePayrollRotations;
    vm.compareWith = "previous 3";
    vm.compareWithEnum;
    vm.endDateStr;
    vm.filters = { IcdCorporationStatus: "Active" };
    vm.filterFinancial = filterFinancial;
    vm.sortColumns = [{ field: "Owner", dir: 1 }]; // Default
    vm.startDateStr;
    vm.topDashboardSummaries;
    vm.topLimit = 15;

    vm.loaded = false;
    vm.selectedRotation;
    vm.selectedCompareRotation;
    vm.pristinePayrollRotations;
    vm.pristinePayrollFinancials;
    vm.payrollRotations;
    vm.payrollFinancials;
    vm.onChangeComparison = onChangeComparison;
    vm.onChangeDivision = onChangeDivision;
    vm.onChangeFilters = onChangeFilters;
    vm.onChangeRotation = onChangeRotation;
    vm.onExportFinancialsReport = onExportFinancialsReport;
    vm.onSetSort = onSetSort;
    vm.onChangeProgram = onChangeProgram;
    let lastRotationFinancials;
    vm.filter = {};
    vm.programs = new kendo.data.ObservableArray([]);
    vm.programID;
    vm.payrollFinancialProgramSummary;
    vm.pristinePayrollFinancialProgramSummary;
    vm.aggregatesProgram;

    function $onInit() {
        vm.startDate = vm.startDateStr ? Date.parse(vm.startDateStr) : null;
        vm.endDate = vm.endDateStr ? Date.parse(vm.endDateStr) : null;
        vm.averageDashboardSummaries = [{
            title: "Rotation Averages",
            glyphicon: "fas fa-chart-bar",
            sort: function (a, b) {
                // Sort ascending by end date.
                return a.endDate > b.endDate ? -1 : 1;
            },
            columns: [{
                field: "endDate",
                title: "R/E",
                format: "{0:MM/dd/yyyy}"
            }, {
                field: "GrossProfit",
                property: function (item) {
                    return item.average.GrossProfit;
                },
                title: "Gross Profit",
                format: "{0:c}",
                cssClass: "text-right"
            }, {
                field: "NetPayoutRate",
                property: function (item) {
                    return item.average.NetPayoutRate;
                },
                title: "Payout / Hr.",
                format: "{0:c}",
                cssClass: "text-right"
            }, {
                field: "NumberOfShowDays",
                property: function (item) {
                    return item.average.NumberOfShowDays;
                },
                title: "Show Days",
                format: "{0:0}",
                cssClass: "text-right"
            }]
        }];

        vm.bottomDashboardSummaries = [{
            title: "Gross Profit",
            glyphicon: "fas fa-dollar-sign",
            sort: function (a, b) {
                return a.GrossProfit < b.GrossProfit ? -1 : 1;
            },
            limit: vm.bottomLimit,
            columns: [{
                field: "Owner",
                title: "Owners"

            }, {
                field: "GrossProfit",
                title: "Gross Profit (Loss)",
                format: "{0:c}",
                cssClass: "text-right"
            }]
        }, {
            title: "Payout / Hr.",
            glyphicon: "fas fa-weight",
            sort: function (a, b) {
                return a.NetPayoutRate < b.NetPayoutRate ? -1 : 1;
            },
            limit: vm.bottomLimit,
            columns: [{
                field: "Owner",
                title: "Owners"
            }, {
                field: "NetPayoutRate",
                title: "Payout / Hr.",
                format: "{0:c}",
                cssClass: "text-right"
            }]
        }, {
            title: "Show Days",
            glyphicon: "fas fa-calendar-alt",
            sort: function (a, b) {
                return a.NumberOfShowDays < b.NumberOfShowDays ? -1 : 1
            },
            limit: vm.bottomLimit,
            columns: [{
                field: "Owner",
                title: "Owners"
            }, {
                field: "NumberOfShowDays",
                title: "Show Days",
                format: "{0:0}",
                cssClass: "text-right"
            }]
        }];

        vm.topDashboardSummaries = [{
            title: "Gross Profit",
            glyphicon: "fas fa-dollar-sign",
            sort: function (a, b) {
                return a.GrossProfit > b.GrossProfit ? -1 : 1;
            },
            limit: vm.topLimit,
            columns: [{
                field: "Owner",
                title: "Owners"
            }, {
                field: "GrossProfit",
                title: "Gross Profit",
                format: "{0:c}",
                cssClass: "text-right"
            }]
        }, {
            title: "Payout / Hr.",
            glyphicon: "fas fa-weight",
            sort: function (a, b) {
                return a.NetPayoutRate > b.NetPayoutRate ? -1 : 1;
            },
            limit: vm.topLimit,
            columns: [{
                field: "Owner",
                title: "Owners"
            }, {
                field: "NetPayoutRate",
                title: "Payout / Hr.",
                format: "{0:c}",
                cssClass: "text-right"
            }]
        }, {
            title: "Show Days",
            glyphicon: "fas fa-calendar-alt",
            sort: function (a, b) {
                return a.NumberOfShowDays > b.NumberOfShowDays ? -1 : 1
            },
            limit: vm.topLimit,
            columns: [{
                field: "Owner",
                title: "Owners"
            }, {
                field: "NumberOfShowDays",
                title: "Show Days",
                format: "{0:0}",
                cssClass: "text-right"
            }]

        }];

        vm.compareWithEnum = {
            none: 'none',
            previous3: 'previous 3',
            previousThisYear: 'previous this year',
            allPrevious: 'all previous'
        };

        vm.footerSummaries = [{
            format: "{0:c}",
            field: "GrossProfit"
        },
        {
            format: "{0:c}",
            field: "NetPayoutRate"
        },
        {
            format: "{0:0}",
            field: "NumberOfShowDays"
        }];

        vm.compareWith = vm.compareWithEnum.previous3;

        performInitialLoad();
    }

    function performInitialLoad() {
        const payrollRotationsLoaded = payrollDashboardService.retrievePayrollRotations()
            .then(function (rotations) {
                // Only show rotations with at least once submitted payroll.
                return rotations.filter(function (rotation) {
                    return rotation.Payrolls.filter(function (payroll) {
                        return payroll.Locked;
                    }).length > 0;
                });
            })
            .then(function (rotations) {
                vm.pristinePayrollRotations = rotations || [];
                vm.payrollRotations = angular.extend([], vm.pristinePayrollRotations);
                return vm.payrollRotations;
            })
            .then(function (rotations) {
                rotations.forEach(function (rotation) {
                    rotation.Text = moment(rotation.StartDate).format("MM/DD/YYYY") + "-" + moment(rotation.EndDate).format("MM/DD/YYYY");
                });
                return rotations;
            })
            .then(function (rotations) {
                vm.selectedRotation = rotations.filter(function (rotation) {
                    return moment(rotation.StartDate).isSame(vm.startDate, 'day')
                        && moment(rotation.EndDate).isSame(vm.endDate, 'day');
                })[0];
                return vm.selectedRotation;
            })
            .then(function (rotation) {
                if (!rotation) return;
                return changeRotation(rotation);
            })
            .then(function () {
                return loadPayrollFinancials(vm.startDate, vm.endDate, vm.selectedCompareRotation)
            })
            .then(updateUrlState)
            .then(loadPayrollFinancialsProgramSummary)
            .then(loadDistinctPrograms);

        const divisionsLoaded = payrollRotationsLoaded.then(loadDivisionsFromSelectedRotation);

        return utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([divisionsLoaded, payrollRotationsLoaded]), "Initial load failed"))
            .then(function () {
                updateShowProgramSummary(vm.selectedRotation);
                vm.loaded = true;
            });
    }

    /**
     * Create a list of divisions based on the list of division countries included in the selected rotation.
     */
    function loadDivisionsFromSelectedRotation() {
        if (vm.selectedRotation) {
            vm.divisions = vm.selectedRotation.DivisionCountries.reduce(function (divisions, dc) {
                let division = divisions.filter(function (division) {
                    return division.Id === dc.DivisionID;
                })[0];
                if (!division) {
                    division = {
                        Id: dc.DivisionID,
                        Name: dc.DivisionName
                    };
                    divisions.push(division);
                }
                return divisions;
            }, []);
        } else {
            vm.divisions = [];
        }
        // Re-select the same division from the updated division list. Kendo won't work right otherwise since
        // it relies on object reference equality.
        vm.selectedDivision = vm.selectedDivision ? vm.divisions.filter(function (division) {
            return vm.selectedDivision.Id === division.Id;
        })[0] : null;
    }

    function onChangeProgram() {
        vm.programID = vm.filter.program ? vm.filter.program.ProgramID : null;
        if (vm.programID) {
            vm.payrollFinancialProgramSummary = vm.pristinePayrollFinancialProgramSummary.filter(function (event) {
                return event.ProgramID === Number(vm.programID);
            });
        } else {
            vm.payrollFinancialProgramSummary = vm.pristinePayrollFinancialProgramSummary;
        }
        vm.aggregatesProgram = aggregateFinancialsProgramSummary(vm.payrollFinancialProgramSummary)
    }

    function onChangeDivision() {
        updateShowProgramSummary(vm.selectedRotation);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(refreshDashboard(), "Refreshing financials data failed"));
    }

    function updateShowProgramSummary(rotation) {
        // Only show the program summary tab if the selected rotation includes RS companies.
        vm.showProgramSummary = rotation && rotation.DivisionCountries.reduce(function (any, dc) {
            return any || dc.DivisionID === divisionService.divisionIDs.RoadShow
                && (!vm.selectedDivision || vm.selectedDivision.Id === dc.DivisionID);
        }, false);
    }

    function onChangeComparison(comparisonType) {
        utilityService.showLoading();
        vm.compareWith = comparisonType;
        let comparisonRotationAggregates;
        if (vm.comparablePayrollRotations) {
            comparisonRotationAggregates = getCompareRotationAggregates(
                vm.comparablePayrollRotations, comparisonType)

        } else {
            comparisonRotationAggregates = $q.when([]);
        }
        comparisonRotationAggregates.then(function (rotationAggregates) {
            vm.compareRotationAggregates = rotationAggregates;
        });

        return $q.all([comparisonRotationAggregates])
            .then(function () {
                const aggregates = [vm.aggregates].concat(vm.compareRotationAggregates);
                vm.payrollFinancialsAverageAggregates = dashboardSummaryService
                    .createDashboardSummaries(vm.averageDashboardSummaries, aggregates);

            })
            .catch(function (ex) {
                console.error(ex);
                alert("Refreshing comparisons failed: " + utilityService.getExceptionMessage(ex));
            })
            .then(utilityService.hideLoading);
    }

    function onChangeFilters() {
        // Re-apply filters from the pristine copy.
        const financials = applyFilters(angular.extend([], vm.pristinePayrollFinancials));
        // Re-apply sort in-place.
        sortFinancials(financials);
    }

    function onChangeRotation() {
        changeRotation(vm.selectedRotation);
        loadDivisionsFromSelectedRotation();
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(refreshDashboard(), "Refreshing financials data failed"));
    }

    function refreshDashboard() {
        return loadPayrollFinancials(vm.startDate, vm.endDate, vm.selectedCompareRotation, vm.selectedDivision)
            .then(loadPayrollFinancialsProgramSummary)
            .then(loadDistinctPrograms)
            .then(updateUrlState);
    }

    function loadPayrollFinancialsProgramSummary() {
        return retrievePayrollFinancialsProgramSummary()
            .then(function (data) {
                vm.pristinePayrollFinancialProgramSummary = vm.payrollFinancialProgramSummary = data || [];
                vm.aggregatesProgram = data ? aggregateFinancialsProgramSummary(vm.payrollFinancialProgramSummary) : {};
            });
    }

    function retrievePayrollFinancialsProgramSummary() {
        if (!vm.selectedDivision || vm.selectedDivision.Id === divisionService.divisionIDs.RoadShow) {
            // The program summary is really only useful to Road Show
            if (vm.startDate && vm.endDate) {
                return payrollFinancialsService.retrievePayrollFinancialsProgramSummary(
                    vm.startDate, vm.endDate, null)
            }
        }
        return $q.when(null);
    }

    function loadDistinctPrograms() {
        vm.programID = null;
        vm.programs = vm.payrollFinancialProgramSummary.filter(function (program) {
            const key = program.ProgramID + '|' + program.ProgramName;
            if (!this[key]) {
                this[key] = true;
                return true;
            }
            return false;
        }, Object.create(null));
    }

    function aggregateFinancialsProgramSummary(financials) {

        const totals = financials.reduce(function (sum, financial) {
            sum.NumberOfShowDays = (sum.NumberOfShowDays || 0) + financial.NumberOfShowDays;
            sum.NoOfHoursWorked = (sum.NoOfHoursWorked || 0) + financial.NoOfHoursWorked;
            sum.HoursPerDay = (sum.HoursPerDay || 0) + financial.HoursPerDay;
            sum.NCR = (sum.NCR || 0) + financial.NCR;
            sum.NCRPerDay = (sum.NCRPerDay || 0) + financial.NCRPerDay;
            sum.NCRPerHour = (sum.NCRPerHour || 0) + financial.NCRPerHour;
            return sum;
        }, {});

        const len = financials.length;
        const average = {};
        Object.keys(totals).forEach(function (totalCol) {
            average[totalCol] = len === 0 ? 0 : totals[totalCol] / len;
        });

        return {
            totals: totals,
            average: average
        };

    }

    function onSetSort(sortField) {
        // TODO: Refactor or use an existing library to handle data table functionality.
        let sortColumn = vm.sortColumns.filter(function (sortColumn) {
            return sortColumn.field === sortField;
        })[0];
        if (!sortColumn) {
            // Start dir at -1 (descending) so that it toggles to ascending order by default.
            sortColumn = { field: sortField, dir: -1 };
            vm.sortColumns.splice(0, vm.sortColumns.length);
            vm.sortColumns.unshift(sortColumn);
        }
        sortColumn.dir *= -1;
        sortFinancials(vm.payrollFinancials);
    }

    function onExportFinancialsReport() {
        const args = {}
        if (vm.startDate) {
            args.startDate = moment(vm.startDate).format("YYYY-MM-DD");
        }
        if (vm.endDate) {
            args.endDate = moment(vm.endDate).format("YYYY-MM-DD");
        }

        args.type = vm.compareWith;
        const queryString = utilityService.queryStringify(args);
        $window.location.href = `${apexApiUrl}/payrolls/financials.xlsx` + queryString
    }

    function changeRotation(rotation) {
        if (rotation) {
            vm.startDate = rotation.StartDate;
            vm.endDate = rotation.EndDate;

            vm.comparablePayrollRotations = getOtherRotations(vm.payrollRotations, rotation).sort(function (a, b) {
                // Sort descending by date.
                return a.StartDate > b.StartDate ? -1 : 1;
            });
            // Compare to the previous rotation by default.
            vm.selectedCompareRotation = vm.comparablePayrollRotations.filter(function (compare) {
                return moment(compare.EndDate).diff(rotation.StartDate, 'day') === -1;
            })[0];
        } else {
            vm.startDate = null;
            vm.endDate = null;

            vm.comparablePayrollRotations = [];
            vm.selectedCompareRotation = null;
        }
        updateShowProgramSummary(rotation);

    }

    function loadPayrollFinancials(startDate, endDate, compareRotation, division) {

        let financials;
        if (!startDate || !endDate) {
            financials = $q.when([]);
        } else {
            financials = payrollFinancialsService.retrievePayrollFinancials(
                startDate, endDate, division ? division.Id : null);
        }

        financials = financials.then(function (financials) {
            vm.pristinePayrollFinancials = financials || [];
            return angular.extend([], vm.pristinePayrollFinancials);
        }).then(applyFilters)
            .then(sortFinancials)
            .then(function (financials) {
                vm.aggregates = aggregateFinancials(financials);
                vm.aggregates.endDate = vm.endDate;
                return financials;
            });

        let comparisonRotationAggregates;
        if (vm.comparablePayrollRotations) {
            comparisonRotationAggregates = getCompareRotationAggregates(vm.comparablePayrollRotations, vm.compareWith)

        } else {
            comparisonRotationAggregates = $q.when([]);
        }

        comparisonRotationAggregates.then(function (rotationAggregates) {
            vm.compareRotationAggregates = rotationAggregates;
        });

        return $q.all([financials, comparisonRotationAggregates])
            .then(function () {
                const aggregates = [vm.aggregates].concat(vm.compareRotationAggregates);
                vm.payrollFinancialsAverageAggregates = dashboardSummaryService
                    .createDashboardSummaries(vm.averageDashboardSummaries, aggregates);
                //Adding last rotation aggrigates at fotter on every top & bottom summaries
                vm.payrollFinancialsTopSummaries = vm.payrollFinancialsTopSummaries.map(function (summary, type) {
                    return retrieveLastRotationSummary(summary, true, type)
                });
                vm.payrollFinancialsBottomSummaries = vm.payrollFinancialsBottomSummaries.map(function (summary, type) {
                    return retrieveLastRotationSummary(summary, false, type)

                });

            });

    }
    function retrieveLastRotationSummary(summary, top, type) {

        let aggregateData;
        if (lastRotationFinancials) {
            switch (vm.footerSummaries[type].field) {
                case "GrossProfit":
                    aggregateData = aggregateFinancials(lastRotationFinancials.sort(function (a, b) {
                        return top ? parseFloat(b.GrossProfit) - parseFloat(a.GrossProfit) :
                            parseFloat(a.GrossProfit) - parseFloat(b.GrossProfit);
                    }).slice(0, top ? vm.topLimit : vm.bottomLimit));
                    summary.total = kendo.format(vm.footerSummaries[type].format, aggregateData.totals.GrossProfit)
                    summary.average = kendo.format(vm.footerSummaries[type].format, aggregateData.average.GrossProfit);
                    break;
                case "NetPayoutRate":
                    aggregateData = aggregateFinancials(lastRotationFinancials.sort(function (a, b) {
                        return top ? parseFloat(b.NetPayoutRate) - parseFloat(a.NetPayoutRate) :
                            parseFloat(a.NetPayoutRate) - parseFloat(b.NetPayoutRate);
                    }).slice(0, top ? vm.topLimit : vm.bottomLimit));
                    summary.total = kendo.format(vm.footerSummaries[type].format, aggregateData.totals.NetPayoutRate)
                    summary.average = kendo.format(vm.footerSummaries[type].format,
                        aggregateData.average.NetPayoutRate);
                    break;
                case "NumberOfShowDays":
                    aggregateData = aggregateFinancials(lastRotationFinancials.sort(function (a, b) {
                        return top ? parseFloat(b.NumberOfShowDays) - parseFloat(a.NumberOfShowDays) :
                            parseFloat(a.NumberOfShowDays) - parseFloat(b.NumberOfShowDays);
                    }).slice(0, top ? vm.topLimit : vm.bottomLimit));
                    summary.total = kendo.format(vm.footerSummaries[type].format, aggregateData.totals.NumberOfShowDays)
                    summary.average = kendo.format(vm.footerSummaries[type].format,
                        aggregateData.average.NumberOfShowDays);
                    break;
                default:
                    break;


            }
        }
        summary.showLastRotationFooter = true;


        return summary;
    }

    function applyFilters(financials) {
        const filteredFinancials = financials.filter(filterFinancial);
        vm.payrollFinancials = filteredFinancials;
        vm.payrollFinancialsTopSummaries = dashboardSummaryService.createDashboardSummaries(
            vm.topDashboardSummaries, angular.extend([], filteredFinancials));
        vm.payrollFinancialsBottomSummaries = dashboardSummaryService.createDashboardSummaries(
            vm.bottomDashboardSummaries, angular.extend([], filteredFinancials));
        return filteredFinancials;
    }

    function getCompareRotationAggregates(comparablePayrollRotations, comparisonType) {
        const previousRotations = vm.comparablePayrollRotations.filter(function (rotation) {
            return rotation.StartDate < vm.startDate;
        });

        let limit;
        switch (comparisonType) {
            case vm.compareWithEnum.none:
                limit = 0;
                break;
            case vm.compareWithEnum.previous3:
                limit = 3;
                break;
            case vm.compareWithEnum.previousThisYear:
                limit = previousRotations.filter(function (rotation) {
                    return moment(rotation.EndDate).isSame(vm.endDate, 'year');
                }).length;
                break;
            case vm.compareWithEnum.allPrevious:
                limit = previousRotations.length;
                break;
            default:
                limit = 0;
                break;
        }

        // Compare with the most recent previous rotations.
        const compareRotationAggregates = previousRotations.slice(0, limit)
            .map(function (rotation, index) {
                // Only care about the aggregates, not the full details of the financials.
                return payrollFinancialsService.retrievePayrollFinancials(rotation.StartDate,
                    rotation.EndDate, vm.selectedDivision ? vm.selectedDivision.Id : null)
                    .then(function (financials) {
                        if (index === 0) {
                            //Get the first previous rotataion financials for manupulation
                            lastRotationFinancials = financials;
                        }
                        return financials;
                    })
                    .then(aggregateFinancials)
                    .then(function (aggregate) {
                        aggregate.endDate = rotation.EndDate;
                        return aggregate;
                    });
            });

        return $q.all(compareRotationAggregates);
    }

    function aggregateFinancials(financials) {

        const totals = financials.reduce(function (sum, financial) {
            sum.NumberOfShowDays = (sum.NumberOfShowDays || 0) + financial.NumberOfShowDays;
            sum.SalesRepHours = (sum.SalesRepHours || 0) + financial.SalesRepHours;
            sum.SalesRepHoursPerShow = (sum.SalesRepHoursPerShow || 0) + financial.SalesRepHoursPerShow;
            sum.NetPayout = (sum.NetPayout || 0) + financial.NetPayout;
            sum.GrossProfit = (sum.GrossProfit || 0) + financial.GrossProfit;
            sum.GrossProfitPercent = (sum.GrossProfitPercent || 0) + financial.GrossProfitPercent;
            sum.SalesRepGrossPay = (sum.SalesRepGrossPay || 0) + financial.SalesRepGrossPay;
            sum.SalesRepGrossPayPercent = (sum.SalesRepGrossPayPercent || 0) + financial.SalesRepGrossPayPercent;
            sum.NetPayoutRate = (sum.NetPayoutRate || 0) + financial.NetPayoutRate;
            sum.SalesRepGrossPayRate = (sum.SalesRepGrossPayRate || 0) + financial.SalesRepGrossPayRate;
            sum.GrossProfitRate = (sum.GrossProfitRate || 0) + financial.GrossProfitRate;
            sum.NetWorthTotalDollars = (sum.NetWorthTotalDollars || 0) + financial.NetWorthTotalDollars;
            return sum;
        }, {});

        const len = financials.length;
        const average = {};
        Object.keys(totals).forEach(function (totalCol) {
            average[totalCol] = len === 0 ? 0 : totals[totalCol] / len;
        });

        return {
            totals: totals,
            average: average
        };
    }

    function sortFinancials(financials) {
        return financials.sort(function (a, b) {
            return vm.sortColumns.reduce(function (comparison, column) {
                // Go through all columns in order and return the value
                // of the first comparison that broke equality (ie, returned non-0).
                if (comparison === 0) {
                    // Still equal.
                    if (a[column.field] < b[column.field]) {
                        return -1 * column.dir;
                    } else if (a[column.field] > b[column.field]) {
                        return column.dir;
                    }
                }
                return comparison;
            }, 0);
        })
    }

    function filterFinancial(financial) {
        return !vm.filters.IcdCorporationStatus || utilityService.equalsInvariant(
            financial.IcdCorporationStatus, vm.filters.IcdCorporationStatus);
    }

    function updateUrlState() {
        const params = {}
        if (vm.startDate) {
            params.startDate = moment(vm.startDate).format("YYYY-MM-DD");
        }
        if (vm.endDate) {
            params.endDate = moment(vm.endDate).format("YYYY-MM-DD");
        }

        const keys = Object.keys(params);
        const queryString = keys.length === 0 ? "" :
            keys.reduce(function (queryString, key, i) {
                return queryString + (i > 0 ? "&" : "?") + key + "=" + params[key]
            }, "");

        window.history.replaceState({}, "Payroll Financials Dashboard",
            "Financials/PayrollFinancials" + queryString);
    }

    /**
     * Retrieve other rotations in the rotations list that fit in the same division and country
     * as the selected rotation.
     */
    function getOtherRotations(rotations, selectedRotation) {
        return rotations.filter(function (rotation) {
            return rotation.DivisionCountries.filter(function (divisionCountry) {
                // Any of the division countries is the same as the selected rotation's division countries.
                return selectedRotation.DivisionCountries.filter(function (selectedDivisionCountry) {
                    return selectedDivisionCountry.DivisionProfileID === divisionCountry.DivisionProfileID;
                }).length > 0 && (!vm.selectedDivision || vm.selectedDivision.Id === divisionCountry.DivisionID);
            }).length > 0;
        });
    }
}
